import { createReducer, on } from "@ngrx/store";
import * as DeviceLocationsActions from "../device-locations/device-locations-actions";
import { DeviceLocationStateInterface } from "src/app/devices/models/deviceLocationStateInterface";

export const initialState: DeviceLocationStateInterface = {
    isLoading: false,
    deviceLocations: [],
    error: null,
};

export const deviceLocationsReducers = createReducer(
    initialState, 

    // get Device Locations
    on(DeviceLocationsActions.getDeviceLocationsByCompany, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceLocationsActions.getDeviceLocationsByCompanySuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        deviceLocations: action.deviceLocations.slice().sort((a, b) => a.name.localeCompare(b.name))
    })),
    on(DeviceLocationsActions.getDeviceLocationsByCompanyFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // create Device Location
    on(DeviceLocationsActions.createDeviceLocation, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceLocationsActions.createDeviceLocationSuccess, (state, action) => ({
        ...state, 
        isLoading: false,
        deviceLocations: [...state.deviceLocations, action.deviceLocation].sort((a, b) => a.name.localeCompare(b.name))
    })),
    on(DeviceLocationsActions.createDeviceLocationFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // update Device Location
    on(DeviceLocationsActions.updateDeviceLocation, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceLocationsActions.updateDeviceLocationSuccess, (state, action) => {
        const updatedManufacturerIndex = state.deviceLocations.findIndex(category => category.id === action.deviceLocation.id);
        
        if (updatedManufacturerIndex === -1) {
            return state; // If category not found, return current state
        }

        const updatedManufacturers = [...state.deviceLocations];
        updatedManufacturers[updatedManufacturerIndex] = action.deviceLocation;

        return {
            ...state,
            isLoading: false,
            deviceLocations: updatedManufacturers.sort((a, b) => a.name.localeCompare(b.name))
        };
    }),
    on(DeviceLocationsActions.updateDeviceLocationFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // delete Device Location
    on(DeviceLocationsActions.deleteDeviceLocation, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceLocationsActions.deleteDeviceLocationSuccess, (state,action) => ({
        ...state, 
        isLoading: false,
        deviceLocations: state.deviceLocations.filter(category => category.id !== action.id)
      })),
    on(DeviceLocationsActions.deleteDeviceLocationFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // clear Device Locations
    on(DeviceLocationsActions.clearDeviceLocations, state => ({
        ...state,
        deviceLocations: []
      }))
);